import { localize } from "@/i18n/translate";
import { useEffect, useRef, useState } from "react";
import { Pause, Play } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
export const HeroVideo = () => {
  const {
    lang
  } = useLang();
  const en = lang !== "de";
  const videoRef = useRef(null);
  const [reducedMotion, setReducedMotion] = useState(() => window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  const [playing, setPlaying] = useState(false);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    const preference = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setReducedMotion(preference.matches);
    preference.addEventListener("change", update);
    return () => preference.removeEventListener("change", update);
  }, []);
  const togglePlayback = async () => {
    const video = videoRef.current;
    if (!video) return;
    if (!video.paused) video.pause();else {
      try {
        await video.play();
      } catch {
        setPlaying(false);
      }
    }
  };
  return <section className="heritage-banner heritage-film" aria-label={localize(en ? "Secure digital infrastructure" : "Sichere digitale Infrastruktur")}>
      <img className="heritage-film-poster" src="/media/secure-infrastructure-poster.jpg" alt={localize(en ? "Server infrastructure with red security lighting" : "Server-Infrastruktur mit roten Lichtakzenten")} width="1280" height="720" fetchPriority="high" />
      {localize(!reducedMotion && !failed && <>
        <video ref={videoRef} className="heritage-film-video" autoPlay muted loop playsInline preload="metadata" poster="/media/secure-infrastructure-poster.jpg" aria-hidden="true" onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onError={() => {
        setFailed(true);
        setPlaying(false);
      }}>
          <source src="/media/secure-infrastructure.mp4" type="video/mp4" />
        </video>
        <button type="button" className="heritage-film-toggle" onClick={togglePlayback} aria-label={localize(playing ? en ? "Pause animation" : "Animation pausieren" : en ? "Play animation" : "Animation abspielen")}>
          {localize(playing ? <Pause size={16} aria-hidden="true" /> : <Play size={16} aria-hidden="true" />)}
          <span>{localize(playing ? en ? "Pause" : "Pause" : en ? "Play" : "Abspielen")}</span>
        </button>
      </>)}
    </section>;
};
